import React, { useState } from 'react'

import {
  PlusCircle as PlusCircleIcon,
  HelpCircle as HelpCircleIcon,
} from 'react-feather'
import { Alert, Skeleton } from '@material-ui/lab'
import {
  Container,
  Button,
  Box,
  Grid,
  TablePagination,
  useMediaQuery,
  Card,
  Typography,
} from '@material-ui/core'
import { isEmpty } from 'lodash'

import { Page, ContentHeader, Permitted, DriveTour } from 'components'
import theme from 'theme'

import { CommitteesTable, DialogNewCommittee } from './components'

import * as service from 'service'
import constants from 'constants/index'

import useFetch from 'hooks/useFetch'
import usePagination from 'hooks/usePagination'
import useStyles from './styles'

const CommitteesMain = () => {
  const [openTour, setOpenTour] = useState(false)
  const [openDialogNewCommittee, setOpenDialogNewCommittee] = useState(false)

  const classes = useStyles()

  const isDesktop = useMediaQuery(theme.breakpoints.up('sm'), {
    defaultMatches: true,
  })

  const { perPage, page, handleChangePage, handleChangeRowsPerPage } =
    usePagination(10)

  const { response, isLoading, refresh } = useFetch(
    service.dponet.committees.get,
    {
      perPage,
      page,
    },
    [page, perPage],
  )

  const committees = response?.data?.committees

  const handleOpenTour = () => setOpenTour((prev) => !prev)

  return (
    <Page title="Todos os comitês">
      <Container maxWidth={false} className={classes.container}>
        <ContentHeader title="Comitês">
          <Permitted tag={constants.permissions.COMMITTEES.MANAGE}>
            <Button
              variant="contained"
              color="primary"
              startIcon={<HelpCircleIcon size={20} />}
              onClick={handleOpenTour}
              id={constants.committees.COMMITTEES_MAIN_DRIVER_STEP_0}
              fullWidth
            >
              Tutorial
            </Button>
            <Button
              variant="contained"
              color="primary"
              startIcon={<PlusCircleIcon size={20} />}
              onClick={() => setOpenDialogNewCommittee(true)}
              fullWidth
            >
              CADASTRAR COMITÊ
            </Button>
          </Permitted>
        </ContentHeader>

        {!isLoading && isEmpty(committees) && (
          <Box margin="2em 0">
            <Alert variant="filled" severity="info">
              <Typography variant="h5">
                A criação de um comitê é uma boa prática para fortalecer a
                governança e a conformidade com a LGPD, mas não é obrigatória.
                Adote se fizer sentido para a estrutura e maturidade da sua
                organização.
              </Typography>
            </Alert>
          </Box>
        )}

        <Card>
          <Box display="flex" width="100%" mt={2}>
            <Grid container>
              <CommitteesTable
                committees={response && committees}
                isLoading={isLoading}
                onEvent={refresh}
              />
            </Grid>
          </Box>

          <Box px={2} display="flex" justifyContent="flex-end">
            {!isLoading && response ? (
              <TablePagination
                component="div"
                count={response?.data?.meta?.totalCount}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                page={page - 1}
                rowsPerPage={perPage}
                rowsPerPageOptions={[5, 10, 25, 100]}
                labelRowsPerPage={isDesktop ? 'Por página' : ''}
                nextIconButtonProps={{ size: 'small' }}
                backIconButtonProps={{ size: 'small' }}
              />
            ) : (
              <Box py="11px">
                <Skeleton variant="rect" width={200} height={30} />
              </Box>
            )}
          </Box>
        </Card>
      </Container>
      <DialogNewCommittee
        open={openDialogNewCommittee}
        setOpen={setOpenDialogNewCommittee}
        onEvent={refresh}
      />
      <DriveTour
        stepsMatrix={constants.committees.COMMITTEES_MAIN_DRIVER_STEPS_OBJECT}
        open={openTour}
        setOpen={setOpenTour}
      />
    </Page>
  )
}

export default CommitteesMain
